<div class="d-flex flex-column" style="min-height: 37rem">
  <app-nav-bar></app-nav-bar>
  <div style="flex-grow: 1">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
